// The signed-in account's roles, fetched once per sign-in
import {ref, computed, watch} from "vue";
import useUserSafe from "@/composables/useUserSafe";
import {authFetch, readJson} from "@/composables/useAuthFetch";

const isAdmin = ref(false);
const isEditor = ref(false);
const isTester = ref(false); // the agents' test accounts (privateMetadata.isTester; ADMIN.md)
let fetchedFor = null;

async function fetchRoles(userId) {
  fetchedFor = userId;
  const response = await authFetch("/api/v1/user/get-roles");
  const roles = response.ok ? await readJson(response) : {};
  isAdmin.value = Boolean(roles.isAdmin);
  isEditor.value = Boolean(roles.isEditor);
  isTester.value = Boolean(roles.isTester);
}

function resetRoles() {
  fetchedFor = null;
  isAdmin.value = false;
  isEditor.value = false;
  isTester.value = false;
}

export default function useRoles() {
  const {isSignedIn, user} = useUserSafe();
  watch([isSignedIn, user], ([signedIn, account]) => {
    if (!signedIn || !account) return resetRoles();
    if (fetchedFor !== account.id) fetchRoles(account.id);
  }, {immediate: true});
  const isStaff = computed(() => isAdmin.value || isEditor.value);
  return {isAdmin, isEditor, isStaff, isTester};
}
